import { lockPrefixes } from 'analyse2/config'

function removeLocksForFileTouch (fileIds) {
  const keys = fileIds.map(id => `${lockPrefixes.fileTouch}${id}`)
  return this.removeLocks(keys)
}

export default removeLocksForFileTouch